import Vue, { DirectiveOptions } from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import i18n from '@/plugins/i18n';
import vuetify from '@/plugins/vuetify';
import * as directives from '@/directives';
import * as filters from '@/filters';

Vue.config.productionTip = false;

// Register global directives
Object.keys(directives).forEach(key => {
  Vue.directive(key, (directives as { [key: string]: DirectiveOptions })[key]);
});

// Register global filter functions
Object.keys(filters).forEach(key => {
  Vue.filter(key, ((filters as unknown) as { [key: string]: Function })[key]);
});

export default new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App),
}).$mount('#app');
